module.exports = __webpack_public_path__ + "img/shuikongpan.6d1dbfd0.png";